module.exports = __webpack_public_path__ + "static/media/concept.4a0bdbde.png";